import { render, staticRenderFns } from "./PieceCount.vue?vue&type=template&id=4c03aa24&scoped=true&"
import script from "./PieceCount.vue?vue&type=script&lang=js&"
export * from "./PieceCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03aa24",
  null
  
)

export default component.exports